import {
  GET_CART_MENU_DONE,
  GET_FORMATTED_MENU_LIST_DONE,
  GET_MEMBER_ORDERS_DONE,
  GET_MENU_DONE,
  GET_MENU_LIST_DONE,
  GETTING_CART_MENU,
  GETTING_MENU,
  GETTING_MENU_LIST,
  SET_ACTIVATED_CATEGORY_DONE,
} from './constants';

export default {
  [GET_CART_MENU_DONE](state, payload) {
    state.cartMenu = payload;
  },
  [GET_FORMATTED_MENU_LIST_DONE](state, payload) {
    state.formattedMenu = payload;
  },
  [GET_MEMBER_ORDERS_DONE](state, value) {
    state.memberOrders = value;
  },
  [GET_MENU_DONE](state, payload) {
    state.menu = payload;
  },
  [GET_MENU_LIST_DONE](state, payload) {
    state.menuList = payload;
  },
  [GETTING_CART_MENU](state, getting) {
    state.gettingCartMenu = getting;
  },
  [GETTING_MENU](state, getting) {
    state.gettingMenu = getting;
  },
  [GETTING_MENU_LIST](state, getting) {
    state.gettingMenuList = getting;
  },
  [SET_ACTIVATED_CATEGORY_DONE](state, categoryId) {
    state.activatedCategory = categoryId;
  },
};
